<template>
    <div class="table-row" :class="[{ public: isPublicInvoice }]">
        <div>
            {{ $t('MoneyLib.item') }}
        </div>

        <div class="price">
            {{ $t('MoneyLib.rate') }}
        </div>

        <div>
            {{ $t('InvoiceLineItemHeader.quantity') }}
        </div>

        <div v-if="isPublicInvoice" class="right-aligned">
            {{ $t('InvoiceLineItemHeader.sales.tax') }}
        </div>

        <div class="right-aligned">
            {{ $t('MoneyLib.total') }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        invoice: Object,
        narrowElement: Boolean,
        isQuote: Boolean,
    },

    computed: {
        isPublicInvoice() {
            return this.invoice?.taxSummaryItems?.length > 0;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common';

.table-row {
    color: $color-ink-800;
    display: grid;
    padding-bottom: $spacing-200;
    margin: 0 $spacing-100;
    line-height: $line-height-sm;
    grid-template-columns: 50% 15% 10% 25%;

    &.public {
        justify-content: space-between;
        grid-template-columns: 40% 10% 10% 15% 10%;
    }
}

@media only screen and ($small) {
    .table-row {
        display: none;
    }
}

.right-aligned {
    justify-self: flex-end;
    text-align: right;
}
</style>
